var gql = require("@apollo/client").gql;

const REVIEWS_AGGREGATE_QUERY_V2 = gql`
	query reviewsProvidersWithAggregate(
		$filter: String
		$limit: Int!
		$offset: Int!
		$sort: String
		$goodView: Boolean
		$providerJoin: Boolean
	) {
		reviewsProvidersV2(
			offset: $offset
			limit: $limit
			filter: $filter
			sort: $sort
			goodView: $goodView
			providerJoin: $providerJoin
			withoutShort: true
		) {
			pagination {
				items_count
				items_total
				per_page
				page_current
				page_total
			}
			data {
				id
				title
				date
				rating
				rating_type
				review
				real
				views_all
				short
				time_of_use
				services_of_use
				order_type_id
				answers {
					count
					list {
						id
						review_id
						user_id
						answer_id
						type
						text
						status
						date
						user {
							name
							photo
							description
						}
					}
				}
				provider {
					id
					name
					url_name
					logo_2
					contacts {
						phones
					}
				}
				region {
					name
					id
				}
				author {
					id
					name
				}
				status {
					code
				}
				specifications {
					list {
						idSpec: id
						name
						value
						image
					}
				}
			}
		}
	}
`;

export default REVIEWS_AGGREGATE_QUERY_V2;
